module.exports = __webpack_public_path__ + "img/scrabble_tiles_photo_cropped_and_resized.bb3a940d.png";